var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationParamIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99219 0.75C10.448 0.75 13.2422 3.54421 13.2422 7C13.2422 8.16075 12.8509 9.51758 12.2139 10.9395C11.5813 12.3514 10.7309 13.773 9.87012 15.0488C9.01078 16.3225 8.15048 17.4377 7.50391 18.2344C7.31282 18.4698 7.13963 18.6765 6.99219 18.8516C6.84474 18.6765 6.67156 18.4698 6.48047 18.2344C5.8339 17.4377 4.9736 16.3225 4.11426 15.0488C3.25346 13.773 2.40308 12.3514 1.77051 10.9395C1.13351 9.51758 0.742188 8.16075 0.742188 7C0.742188 3.54421 3.5364 0.75 6.99219 0.75ZM6.99219 3.75C5.19797 3.75 3.74219 5.20579 3.74219 7C3.74219 8.79421 5.19797 10.25 6.99219 10.25C8.7864 10.25 10.2422 8.79421 10.2422 7C10.2422 5.20579 8.7864 3.75 6.99219 3.75Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationParamIcon);
export default __webpack_public_path__ + "static/media/LocationParamIcon.b45212e0c24361400d377708a7438966.svg";
export { ForwardRef as ReactComponent };